import { Search, Close } from '@carbon/react/icons';
import { InputHTMLAttributes } from 'react';
import { Button } from '@carbon/react';
import classNames from 'classnames';

import style from './debounced-input.module.scss';
import { useDebouncedChange } from './use-debounced-change';

const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  className,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
  className?: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'>) => {
  const [value, handleChange] = useDebouncedChange(
    initialValue,
    onChange,
    debounce
  );

  const debouncedClassName = classNames(style.searchField, className);

  return (
    <div className={debouncedClassName}>
      <Search className={style.searchIcon} />
      <input
        {...props}
        value={value}
        className={style.searchInput}
        onChange={(e) => handleChange(e.target.value)}
      />
      {value && (
        <Button
          size="sm"
          kind="ghost"
          onClick={() => handleChange('')}
          className={style.clearBtn}
          aria-label="Clear search input"
        >
          <Close />
        </Button>
      )}
    </div>
  );
};

export { DebouncedInput };
